import React, { Component } from 'react';
import authUser from '../assets/js/auth'
import companyLogo from '../assets/images/logo.png';
import Login from './Login/Login';
import { Link } from 'react-scroll';
import './Navigation.css';

let button;

class Navigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openSubMenu: false,
        };
    }

    componentWillMount() {
        const LOGIN_BUTTON = <li className="nav-link login-btn"><button onClick={this.props.onOpenModalLogin} >Login</button></li>
        const MYACCOUNT_BUTTON =
            <>
                <li className="me-menu-children nav-link login-btn" onClick={this.openSubMenu}><button>Account</button>
                    <ul className={this.state.openSubMenu ? "me-sub-menu" : "me-sub-menu sub-menu-hide"}>
                        <li className="nav-link children"><button onClick={this.ToAccount}>Profile</button></li>
                        <li className="nav-link children"><button onClick={this.props.handleLogout}>Logout</button></li>
                    </ul>
                </li>
            </>

        authUser.isAuthenticated()
        if (authUser.authenticated === "false") {
            button = LOGIN_BUTTON
        } else {
            button = MYACCOUNT_BUTTON
        }

    }

    openSubMenu = () => {
        this.setState({ openSubMenu: !this.state.openSubMenu })
    }

    ToAccount = () => {
        window.location.href = "https://charryweb.netlify.app/"
    }

    render() {

        return (
            <>
                <div className="me-main-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-3 col-7">
                                <div className="me-logo navbar-logo">
                                    <a href="/"><img src={companyLogo} alt="logo" className="img-fluid" /></a>
                                </div>
                            </div>
                            <div className="col-sm-9 col-5">
                                <div className={this.props.open ? "me-menu me-menu-open" : "me-menu"}>
                                    <ul>
                                        <li>
                                            <Link
                                                activeClass="active"
                                                className="nav-link"
                                                to="banner-wrapper"
                                                spy={true}
                                                smooth={true}
                                                offset={-70}
                                                duration={500}
                                            ><button onClick={this.props.toggleNavbar}>Home</button></Link>
                                        </li>
                                        <li>
                                            <Link
                                                activeClass="active"
                                                className="nav-link"
                                                to="valuation-wrapper"
                                                spy={true}
                                                smooth={true}
                                                offset={-70}
                                                duration={500}
                                            ><button onClick={this.props.toggleNavbar}>Valuation</button></Link>
                                        </li>
                                        <li>
                                            <Link
                                                activeClass="active"
                                                className="nav-link"
                                                to="buytokens-wrapper"
                                                spy={true}
                                                smooth={true}
                                                offset={-70}
                                                duration={500}
                                            ><button onClick={this.props.toggleNavbar}>Buy Tokens</button></Link>
                                        </li>
                                        <li>
                                            <Link
                                                activeClass="active"
                                                className="nav-link"
                                                to="me-counter"
                                                spy={true}
                                                smooth={true}
                                                offset={-70}
                                                duration={500}
                                            ><button onClick={this.props.toggleNavbar}>Overview</button></Link>
                                        </li>
                                        <li>
                                            <Link
                                                activeClass="active"
                                                className="nav-link"
                                                to="roadmap-wrapper"
                                                spy={true}
                                                smooth={true}
                                                offset={-70}
                                                duration={500}
                                            ><button onClick={this.props.toggleNavbar}>Roadmap</button></Link>
                                        </li>
                                        <li>
                                            <Link
                                                activeClass="active"
                                                className="nav-link"
                                                to="packages-wrapper"
                                                spy={true}
                                                smooth={true}
                                                offset={-70}
                                                duration={500}
                                            ><button onClick={this.props.toggleNavbar}>Packages</button></Link>
                                        </li>
                                        <li>
                                            {button}
                                        </li>
                                    </ul>
                                    <div className="me-toggle-nav" onClick={this.props.toggleNavbar}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                    <select style={{ width: "70px" }}
                                        id="currency"
                                        onChange={this.props.handleCurrencyChange}
                                        defaultValue={this.props.currency}
                                    >
                                        <option value="" hidden>
                                            Select Currency
                                        </option>
                                        <option value="inr">
                                            INR
                                        </option>
                                        <option value="usd">
                                            USD
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Login
                    login={this.props.login}
                    onCloseModalLogin={this.props.onCloseModalLogin}
                    value={this.props.value}
                    handleChange={this.props.handleChange}
                    hashHandleChange={this.props.hashHandleChange}
                    handleLoginMobile={this.props.handleLoginMobile}
                />

            </>
        );
    }
}

export default Navigation;